const ChecklistFolder = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M12.3333 7.11337V4.22004C12.3333 3.68671 12.1266 3.18004 11.7466 2.80671L9.85992 0.920041C9.47992 0.540041 8.97992 0.333374 8.44659 0.333374L3.02659 0.333374C2.29325 0.333374 1.69325 0.933374 1.69325 1.66671L1.69325 4.33337H1.66659C0.933252 4.33337 0.333252 4.93337 0.333252 5.66671L0.333252 12.3334C0.333252 13.0667 0.933252 13.6667 1.66659 13.6667L12.3333 13.6667C13.0666 13.6667 13.6666 13.0667 13.6666 12.3334V9.00004C13.6666 8.10671 13.1199 7.38004 12.3333 7.11337ZM3.02659 1.66671L8.44659 1.66671C8.62659 1.66671 8.79325 1.73337 8.91992 1.86004L10.8066 3.74671C10.9333 3.87337 10.9999 4.04004 10.9999 4.22004V7.00004H9.39992L8.59992 5.46671C8.26659 4.80004 7.59992 4.33337 6.79992 4.33337L3.02659 4.33337L3.02659 1.66671ZM1.66659 5.66671L6.86659 5.66671C7.13325 5.66671 7.33325 5.80004 7.46659 6.06671L7.93325 7.00004L1.66659 7.00004L1.66659 5.66671Z"
      fill="#0B41CD"
    />
  </svg>
);

export default ChecklistFolder;
